import { GoogleDrive } from 'blaze-ui/icons'
import { ExternalIntegrationEnum } from 'api/clients/ExternalIntegrationsClient'
import { useExternalIntegrations } from 'components/ExportModal/ExternalIntegrations/ExternalIntegrations'
import { useConnectAccountPopup } from 'components/Onboarding/useConnectAccountPopup'
import { InitiateOauthTrigger } from 'components/ConnectIntegrationTrigger/InitiateOauthTrigger'
import { Button } from 'blaze-ui/Button'
import { Check } from 'blaze-ui/icons/16'
import Styles from '../QuestionnairePanel.module.scss'
import { Heading } from 'blaze-ui/Heading/Heading'

interface Props {
  onAdvance: () => void
  onSkip: () => void
}

export const GoogleDriveStep = ({ onAdvance, onSkip }: Props) => {
  const { getIntegration } = useExternalIntegrations()
  const isConnected = !!getIntegration(ExternalIntegrationEnum.GoogleDrive)
  const { connect } = useConnectAccountPopup({ showToast: true })

  return (
    <>
      <div className={Styles.driveCard}>
        <div className={Styles.driveCardLeft}>
          <GoogleDrive size={32} />
          <Heading level={4}>Google Drive</Heading>
        </div>
        {isConnected ? (
          <span className={Styles.connectedBadge}>
            <Check size={14} />
            Connected
          </span>
        ) : (
          <InitiateOauthTrigger provider={ExternalIntegrationEnum.GoogleDrive} popUp onInitiatedOauth={connect}>
            <Button variant="primary" size="lg" className={Styles.connectButton}>
              Connect
            </Button>
          </InitiateOauthTrigger>
        )}
      </div>
      <div className={Styles.actions}>
        {isConnected ? (
          <Button onPress={onAdvance} size="lg" variant="secondary">
            Looks good!
          </Button>
        ) : (
          <Button onPress={onSkip} size="lg" variant="secondary">
            Skip
          </Button>
        )}
      </div>
    </>
  )
}
